import React, { useState, useEffect, useContext } from 'react';

import Socials from './Socials';
import MobileNav from './MobileNav';

import { Link, useLocation } from 'react-router-dom';
import { CursorContext } from '../context/CursorContext';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/hotels', label: 'Hotels' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (to) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header
      className='fixed top-0 left-0 w-full z-30 px-[30px] md:px-[40px] lg:px-[100px] h-[60px] md:h-[80px] flex items-center transition-all duration-300'
      style={{
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        boxShadow: scrolled ? '0 1px 0 rgba(0,0,0,0.08)' : 'none',
      }}
    >
      <div className='flex flex-col md:flex-row md:items-center w-full justify-between'>
        {/* logo */}
        <Link to={'/'} className='font-primary transition hover:text-primary'>
          <span className='text-primary font-semibold text-lg tracking-tight'>Emma Tysinger</span>
          <small className='block text-[#999] text-xs tracking-[0.15em] uppercase font-normal mt-0.5'>
            Photography · Paris
          </small>
        </Link>

        {/* nav - desktop */}
        <nav
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className='hidden md:flex items-center gap-x-5 lg:gap-x-9 font-secondary'
        >
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-xs tracking-widest uppercase transition hover:text-primary ${
                isActive(item.to)
                  ? 'text-primary font-bold underline underline-offset-4'
                  : 'text-[#888]'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* socials */}
      <Socials />
      {/* mobile nav */}
      <MobileNav />
    </header>
  );
};

export default Header;